import { message } from 'antd';
import { all, call, put, takeEvery } from 'redux-saga/effects';
import { getTypistWorkloadListAPI } from '../../../services/typist-service';
import {
    FETCH_TYPIST_WORKLOAD_LIST,
    FETCH_TYPIST_WORKLOAD_LIST_ERROR,
    FETCH_TYPIST_WORKLOAD_LIST_START,
    FETCH_TYPIST_WORKLOAD_LIST_SUCCESS,
    SET_TYPIST_WORKLOAD_LIST_FILTER_AND_SORT,
    SET_TYPIST_WORKLOAD_LIST_PAGINATION,
} from '../../actions/typist/typistWorkloadListAction';

const getWorkloadVisits = (data) => {
    return data.typWorkloadList || data.workloadList || data.typWorklist || data.visits || data.content || [];
};

function* fetchTypistWorkloadList({ payload }) {
    try {
        yield put({ type: FETCH_TYPIST_WORKLOAD_LIST_START });
        const response = yield call(getTypistWorkloadListAPI, payload);
        if (response.success) {
            const visits = getWorkloadVisits(response.data);
            const pagination = {
                currentPage: payload.page,
                pageSize: payload.size,
                totalPages: response.data.totalPages,
                totalItems: response.data.totalItems,
            };
            yield put({ type: FETCH_TYPIST_WORKLOAD_LIST_SUCCESS, visits });
            yield put({ type: SET_TYPIST_WORKLOAD_LIST_PAGINATION, pagination });
            yield put({ type: SET_TYPIST_WORKLOAD_LIST_FILTER_AND_SORT, payload: { ...payload } });
        } else {
            yield put({ type: FETCH_TYPIST_WORKLOAD_LIST_ERROR, error: response.error });
            message.error(response.error || 'Failed to fetch workload list!');
        }
    } catch (error) {
        yield put({ type: FETCH_TYPIST_WORKLOAD_LIST_ERROR, error });
        message.error('Failed to fetch workload list!');
    }
}

function* typistWorkloadListWatcher() {
    yield takeEvery(FETCH_TYPIST_WORKLOAD_LIST, fetchTypistWorkloadList);
}

export default function* rootSaga() {
    yield all([
        typistWorkloadListWatcher(),
    ]);
}
